import Vue from 'vue'
import moment from 'moment'
import i18nPresenter from '@/i18nPresenter'
import util from '@/util'
import textUtil from '@/utils/textUtil'

Vue.filter('capitalize', (value) => {
  if (!value) return ''
  value = value.toString()
  const arr = value.split(' ')
  const capitalized_array = []
  arr.forEach((word) => {
    const capitalized = word.charAt(0).toUpperCase() + word.slice(1)
    capitalized_array.push(capitalized)
  })
  return capitalized_array.join(' ')
})

Vue.filter('truncate', (value, limit) => {
  return value.substring(0, limit)
})

Vue.filter('tailing', (value, tail) => {
  return value + tail
})

Vue.filter('time', (value, is24HrFormat = false) => {
  if (value) {
    const date = new Date(Date.parse(value))
    let hours = date.getHours()
    const min = (date.getMinutes() < 10 ? '0' : '') + date.getMinutes()
    if (!is24HrFormat) {
      const time = hours > 12 ? 'AM' : 'PM'
      hours = hours % 12 || 12
      return `${hours}:${min} ${time}`
    }
    return `${hours}:${min}`
  }
})

Vue.filter('date', (value, fullDate = false) => {
  value = String(value)
  const date = value.slice(8, 10).trim()
  const month = value.slice(4, 7).trim()
  const year = value.slice(11, 15)

  if (!fullDate) return `${date} ${month}`
  return `${date} ${month} ${year}`
})

Vue.filter('dateTimeAgo', (value, useShorterText = true) => {
  const valueTime = moment(new Date(value), 'YYYYMMDD HH:mm:ss').locale('en')
  const differenceInSeconds = moment().locale('en').diff(valueTime, 'seconds')
  // 7 days = 604800 seconds
  if (differenceInSeconds > 604800) {
    return valueTime.format('DD MMM YYYY')
  }
  let result = moment(new Date(value), 'YYYYMMDD').locale('en').fromNow()
  if (result == 'a few seconds ago' && useShorterText) {
    result = 'Just now' // reason: in prez list, long text could break layout
  }
  return result
})

Vue.filter('dateTimeAgoV2', (value) => {
  const { locale } = i18nPresenter
  const valueTime = moment(value).locale(locale)
  const SECONDS_IN_A_WEEK = 7 * 24 * 60 * 60
  const differenceInSeconds = moment().locale(locale).diff(valueTime, 'seconds')
  if (differenceInSeconds > SECONDS_IN_A_WEEK) {
    return valueTime.format('DD MMM YYYY')
  }
  return valueTime.fromNow()
})

Vue.filter('dateTime', (value) => {
  return moment(new Date(value)).locale('en').format('DD-MM-YYYY hh:mm A')
})

Vue.filter('dateTimeFirst', (value) => {
  const timestamp = parseInt(value, 10)
  return moment(new Date(timestamp)).locale('en').format('hh:mmA DD MMM YYYY')
})

Vue.filter('dateBill', (value) => {
  return moment(value).locale('en').format('DD MMM YYYY')
})

Vue.filter('dateTimeStamp', (value) => {
  return moment(new Date(value)).locale('en').format('DD MMM YYYY, hh:mm A')
})

Vue.filter('dateTimeStampV2', (value) => {
  return moment(value).locale(i18nPresenter.locale).format('DD MMM YYYY, hh:mm A')
})

Vue.filter('csv', (value) => {
  return value.join(', ')
})

Vue.filter('filter_tags', (value) => {
  return value.replace(/<\/?[^>]+(>|$)/g, '')
})

Vue.filter('k_formatter', (num) => {
  return num > 999 ? `${(num / 1000).toFixed(1)}k` : num
})

Vue.filter('sanitize', textUtil.sanitize)

Vue.filter('dateTimeAgoQuestion', (value) => {
  const valueTime = moment(new Date(value), 'YYYYMMDD HH:mm:ss')
  const differenceInSeconds = moment().diff(valueTime, 'seconds')
  // 7 days = 604800 seconds
  if (differenceInSeconds > 604800) {
    return valueTime.format('DD MMM YYYY')
  }
  return moment(new Date(value), 'YYYYMMDD').fromNow()
})

Vue.filter('textAvatar', (value) => {
  if (!value) value = ''
  value = value.trim()
  if (value) {
    return value.match(/./ug)[0]
  }
  return ' '
})

Vue.filter('formatNumber', (value) => {
  if (!value) return 0
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
})

Vue.filter('floatNumber', (value) => {
  if (!value) return '0.00'
  return (Math.round(value * 100) / 100).toFixed(2)
})

Vue.filter('currencyFormat', (value, _currency) => {
  const currency = _currency.toUpperCase()
  // For undefined, null, or zero values
  if (value == null || value === 0) {
    if (currency === 'VND') {
      return '0'
    }
    return '0.00'
  }

  // Convert value to positive
  value = Math.abs(value)

  // Format value based on currency
  let formattedValue
  /**
   * Remember to add extra currency formatting here, other than VND that does not have decimal point
   */
  if (currency === 'VND') {
    formattedValue = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
  } else {
    formattedValue = (value / 100).toFixed(2)
  }

  return formattedValue
})

Vue.filter('formatTotalPoint', textUtil.formatNumber)

Vue.filter('capitalizeFirstLetter', (string) => {
  if (!string) return ''
  return string.charAt(0).toUpperCase() + string.slice(1)
})

Vue.filter('profanity', (sentence) => {
  if (!sentence) return ''
  return util.filterProfaneWordsWrapper(sentence)
})

Vue.filter('convertHMS', (value) => {
  const sec = parseInt(value, 10) // convert value to number if it's string
  let hours = Math.floor(sec / 3600) // get hours
  let minutes = Math.floor((sec - (hours * 3600)) / 60) // get minutes
  let seconds = sec - (hours * 3600) - (minutes * 60) //  get seconds
  // add 0 if value < 10; Example: 2 => 02
  if (hours < 10) { hours = `0${hours} ` }
  if (minutes < 10) { minutes = `0${minutes}` }
  if (seconds < 10) { seconds = `0${seconds}` }
  return `${minutes}:${seconds}`
})

Vue.filter('MMmSSs', (value) => {
  const { minutes, secondsLeft } = util.getHoursMinutesSeconds(value)
  if (minutes) {
    return `${minutes}m:${secondsLeft}s`
  }

  return `${secondsLeft}s`
})

Vue.filter('trim', (value) => {
  return String(value ?? '').trim()
})

Vue.filter('dateFormat', (value, format) => {
  if (!value || !format) return ''
  return moment(value).locale(i18nPresenter.locale).format(format)
})
